import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

import { removeStorageData, setStorageData } from '~/utils/storage';

import { useEffectOnce } from './lifecycle';

export const ReferrerContext = createContext<{
  referrer: string | null;
  setRefferer: (referrer: string) => void;
} | null>(null);

export const useReferrerContext = () => {
  const context = useContext(ReferrerContext);

  if (!context) {
    throw new Error('Not found Context');
  }

  return context;
};

export const ReferrerProvider = ({ children }: { children: ReactNode }) => {
  const [referrer, setRefferer] = useState<string | null>(null);
  const contextValue = useMemo(() => {
    return { referrer, setRefferer };
  }, [referrer]);

  return (
    <ReferrerContext.Provider value={contextValue}>
      {children}
    </ReferrerContext.Provider>
  );
};

// 마켓 홈화면에서, referrer=XX 정보가 있을 경우 저장
export const useProvideReferrer = () => {
  const { setRefferer } = useReferrerContext();
  const { query } = useRouter();

  useEffectOnce(() => {
    const referrer = query.referrer as string | undefined;

    if (referrer) {
      setRefferer(referrer);
      setStorageData('REFERRER', referrer);
    } else {
      removeStorageData('REFERRER');
    }
  });
};

export const usePosOpenedByReferrer = () => {
  const { referrer } = useReferrerContext();

  return referrer === 'connect_service';
};
